export const convertDollarToCents = (dollarVal: number) => dollarVal * 100;
